
  import createMeisterIcons from '../src/createMeisterIcons';

  const Folder = createMeisterIcons("folder", [["path",{"fill":"currentColor","d":"M3.75 4.2c0-.286.164-.45.45-.45h8.1c.731 0 1.446.45 1.715 1.055l.009.02.74 1.425H3.75zm-1.5 2.05V4.2c0-1.114.836-1.95 1.95-1.95h8.1c1.26 0 2.538.74 3.075 1.923l1.08 2.077H17A4.76 4.76 0 0 1 21.75 11v6A4.76 4.76 0 0 1 17 21.75H7c-2.726 0-4.75-2.148-4.75-4.75zm1.5 1.5V17c0 1.798 1.376 3.25 3.25 3.25h10A3.26 3.26 0 0 0 20.25 17v-6A3.26 3.26 0 0 0 17 7.75z","key":"e1da413d10abb1ca17209a65c82189c29d317549","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Folder
  